import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { RestaurantReservation } from '@plys/src/infrastructure/dto/products.dto';

import { CartState } from '../../application/states/cart.state';
import { LocaleCurrencyPipe } from '../locale-currency.pipe';

@Component({
  selector: 'plys-cart-preview',
  standalone: true,
  imports: [LocaleCurrencyPipe, CommonModule, TranslocoModule, MatIconModule],
  templateUrl: './cart-preview.component.html',
  styleUrls: ['./cart-preview.component.scss'],
})
export class CartPreviewComponent {
  @Input() displaySeatsOnly = false;
  @Input() hideSummary = false;
  Math = Math;
  total$ = this.cartState.total$;
  pendingAmount$ = this.cartState.pendingAmount$;
  tickets$ = this.cartState.tickets$;
  items$ = this.cartState.displayUniqueItems$;
  giftCards$ = this.cartState.giftCards$;
  boscoopcards$ = this.cartState.boscoopcards$;
  deferredPayments$ = this.cartState.deferredPayments$;
  discounts$ = this.cartState.discounts$;
  seatsAssigned$ = this.cartState.seatsAssigned$;
  reservations$ = this.cartState.restaurantReservations$;
  paymentMethod$ = this.cartState.paymentMethod$;
  constructor(
    private cartState: CartState,
    private snackBar: MatSnackBar,
    private translocoService: TranslocoService
  ) {}

  removeGiftCard(id: string): void {
    this.cartState.removeGiftCard(id).subscribe({
      next: () => {
        this.snackBar.open(
          this.translocoService.translate('giftcard.removed'),
          this.translocoService.translate('global.close'),
          { duration: 5000 }
        );
      },
    });
  }

  removeBioscoopcard(id: string): void {
    this.cartState.removeBioscoopcard(id).subscribe({
      next: () => {
        this.snackBar.open(
          this.translocoService.translate('bioscoopbon.removed'),
          this.translocoService.translate('global.close'),
          { duration: 5000 }
        );
      },
    });
  }

  removeDiscount(discountCodeId: string): void {
    this.cartState.removeDiscount(discountCodeId).subscribe();
  }

  public isBeforeShow(reservation: RestaurantReservation): boolean {
    const tableStart = new Date(reservation.table_start);

    const before = new Date(reservation.before);
    return tableStart < before;
  }

  public isReservationSetByUser(reservation: RestaurantReservation): boolean {
    return reservation.notes !== null;
  }
}
